import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes =
  [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/home/index.vue'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/detail',
      name: 'detail',
      component: () => import('../views/home/detail.vue'),
      meta: {
        title: '山东军民两用技术交易中心'
      }
    }
  ]
const createRouter = () => new Router({
  mode: 'hash', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: routes
})

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/rczk/router/index.js